<template>
  <div>
    <ValidationObserver ref="observer">
      <div class="mt-5 vx-row">
        <div class="vx-col w-full">
          <ul class="heading-ul mb-5">
            <li>
              <router-link to="/setup/team-mapping" class="vx-row">
                <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
                <h4>{{ $t("setup.label.EditTeamMapping") }}</h4>
              </router-link>
            </li>
          </ul>
        </div>
        <vx-card title no-shadow card-border>
          <div class="vx-row">
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label"
                  >{{ $t("setup.label.CityName") }}
                  <span class="required"> *</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('setup.label.CityName')"
                >
                  <v-select
                    label="cityName"
                    v-model="cityName"
                    disabled
                    :options="networkEleData.cityDetailsData"
                    :placeholder="$t('placeholder.label.SelectOne')"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="min-w-200 w-full mb-2"
                    :reduce="(cityName) => cityName.cityName"
                  >
                    <template v-slot:option="option">{{
                      option.cityName
                    }}</template>
                  </v-select>
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label"
                  >{{ $t("setup.label.Category") }}
                  <span class="required"> *</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('setup.label.Category')"
                >
                  <v-select
                    label="mCodeValue"
                    v-model="categoryId"
                    disabled
                    :options="networkEleData.categoryData"
                    :placeholder="$t('placeholder.label.SelectOne')"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="min-w-200 w-full mb-2"
                    @input="getcategoryTemplate()"
                    :reduce="(mCodeValue) => mCodeValue.id"
                  >
                    <template v-slot:option="option">{{
                      option.mCodeValue
                    }}</template>
                  </v-select>
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label"
                  >{{ $t("setup.label.SubCategory") }}
                  <span class="required"> *</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('setup.label.SubCategory')"
                >
                  <v-select
                    label="subCategory"
                    v-model="subcategoryId"
                    multiple
                    :options="categoryTemplate"
                    :placeholder="$t('placeholder.label.SelectOne')"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="min-w-200 w-full mb-2"
                    :reduce="(id) => id.id"
                  >
                    <template v-slot:option="option">{{
                      option.subCategory
                    }}</template>
                  </v-select>
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label"
                  >{{ $t("setup.label.Team") }}
                  <span class="required"> *</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('setup.label.Team')"
                >
                  <v-select
                    v-if="
                      networkEleData &&
                      networkEleData.ticketTeamData &&
                      networkEleData.ticketTeamData.pageItems
                    "
                    label="teamDescription"
                    v-model="teamId"
                    :options="networkEleData.ticketTeamData.pageItems"
                    :placeholder="$t('placeholder.label.SelectOne')"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="min-w-200 w-full mb-2"
                    :reduce="(id) => id.id"
                  >
                    <template v-slot:option="option">{{
                      option.teamDescription
                    }}</template>
                  </v-select>
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label"
                  >{{ $t("setup.label.TeamHead") }}
                  <span class="required"> *</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('setup.label.TeamHead')"
                >
                  <v-select
                    label="username"
                    v-model="userId"
                    disabled
                    :options="networkEleData.appUserData"
                    :placeholder="$t('placeholder.label.SelectOne')"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="min-w-200 w-full mb-2"
                    :reduce="(id) => id.id"
                  >
                    <template v-slot:option="option">{{
                      option.username
                    }}</template>
                  </v-select>
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label"
                  >{{ $t("setup.label.ServiceType") }}
                  <span class="required"> *</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('setup.label.ServiceType')"
                >
                  <v-select
                    label="mCodeValue"
                    v-model="serviceType"
                    :options="networkEleData.ticketTypeData"
                    :placeholder="$t('placeholder.label.SelectOne')"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="min-w-200 w-full mb-2"
                    :reduce="(id) => id.mCodeValue"
                  >
                  </v-select>
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
          </div>
        </vx-card>
      </div>
      <div class="vx-row center">
        <div class="vx-col w-full">
          <vs-button
            color="primary"
            type="border"
            class="mb-2 footerButton-cancel"
            @click="cancel"
            >{{ $t("setup.label.Cancel") }}</vs-button
          >
          <vs-button class="mr-3 mb-2 footerButton-next" @click="editTeam">{{
            $t("setup.label.Submit")
          }}</vs-button>
        </div>
      </div>
    </ValidationObserver>
  </div>
</template>
<script>
import vSelect from "vue-select";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { mapState } from "vuex";

export default {
  data() {
    return {
      networkEleData: {},
      cityName: "",
      categoryId: "",
      subcategoryId: "",
      serviceType: "Service2",
      teamId: "",
      userId: "",
      systemById: {},
    };
  },
  components: {
    "v-select": vSelect,
    ValidationProvider,
    ValidationObserver,
  },

  computed: {
    ...mapState({
      editMappingTemplate: (state) => state.teamMapping.editMappingTemplate,
      categoryTemplate: (state) => state.teamMapping.categoryTemplate,
      createTemplate: (state) => state.teamMapping.createTemplate,
    }),
  },
  methods: {
    async getTeamMappingList() {
      try {
        const response = await this.$store.dispatch(
          "teamMapping/fetchEditTeamMappingTemplate",
          this.$route.params.id
        );
        this.systemById = response.data;
        const categoryData = this.networkEleData.categoryData.find(
          (category) => category.mCodeValue === this.systemById.category
        );
        this.cityName = this.systemById.cityName;
        this.categoryId = categoryData.id;
        this.serviceType = this.systemById.serviceType;
        this.teamId = this.systemById.teamId;
        this.userId = this.systemById.userId;

        await this.getcategoryTemplate();
        const subCategoryData = this.categoryTemplate.find(
          (subCategory) =>
            subCategory.subCategory === this.systemById.subcategory
        );
        // this.subcategoryId = subCategoryData ? subCategoryData.id : "";
        this.subcategoryId = this.systemById.subcategories;
        this.originalSubcategoryIds = [...this.systemById.subcategories];
      } catch (e) {
        this.$toasted.error(e.message);
      }
    },
    async getCreateTemplate() {
      try {
        const response = await this.$store.dispatch(
          "teamMapping/fetchCreateTemplate"
        );
        this.networkEleData = response.data;
      } catch (e) {
        this.$toasted.error(e.message);
      }
    },
    async getcategoryTemplate() {
      this.subcategoryId = "";
      try {
        await this.$store.dispatch(
          "teamMapping/fetchCategoryTemplate",
          this.categoryId
        );
      } catch (e) {
        this.$toasted.error(e.message);
      }
    },
    async editTeam() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;
      let deletedSubcategoryArray = this.originalSubcategoryIds.filter(
        (id) => !this.subcategoryId.includes(id)
      );
      let payload = {
        id: this.$route.params.id,
        data: {
          cityName: this.cityName,
          categoryId: this.categoryId,
          subcategoryId: this.subcategoryId,
          serviceType: this.serviceType,
          teamId: this.teamId,
          userId: this.userId,
        },
      };
      if (deletedSubcategoryArray && deletedSubcategoryArray.length > 0) {
        payload.data.deletedSubcategoryArray = deletedSubcategoryArray;
      }

      try {
        await this.$store.dispatch("teamMapping/updateTeamMapping", payload);
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Team Mapping Edited Successfully!",
          type: "success",
        });
        this.$router.push(`/setup/team-mapping`);
      } catch (error) {
        let errorMessage = error && error.toString().replace(/^Error:\s*/, "");
        this.$swal({
          title: "Error",
          icon: "error",
          text: errorMessage,
          type: "error",
        });
      }
    },
    cancel() {
      this.$router.push(`/setup/team-mapping`);
    },
  },
  watch: {
    teamId(newTeamId) {
      if (
        this.networkEleData &&
        this.networkEleData.ticketTeamData &&
        this.networkEleData.ticketTeamData.pageItems
      ) {
        const selectedTeam = this.networkEleData.ticketTeamData.pageItems.find(
          (team) => team.id === newTeamId
        );
        if (selectedTeam) {
          this.userId = selectedTeam.userId;
        }
      }
    },
  },
  async mounted() {
    await this.getCreateTemplate();
    this.getTeamMappingList();
  },
};
</script>
